import { FolderHierarchy } from "@/model/data/FolderHierarchy";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { ClientProfile } from "@/model/data/authentication/ClientProfile";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class FetchClientProfilesResponse extends ServiceResponseData {
    clientProfiles: ClientProfileExtended[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response && response.data && response.data.Payload) {
            response.data.Payload.forEach((u) => {
                this.clientProfiles.push(ClientProfileExtended.parseFrom(u));
            });
        }
    }
}

export class ClientProfileExtended extends ClientProfile {
    associatedUsersCount: number;
    associatedExternalUsersCount: number;

    static parseFrom(data: any): ClientProfileExtended {
        let res = new ClientProfileExtended();
        res.name = data.Name;
        res.windowsGroup = data.WindowsGroup;
        res.authPluginGroup = data.AuthPluginGroup;
        res.privileges = new ClientPrivileges(data.Privileges.PrivilegeName);
        res.associatedUsersCount = data.AssociatedUsersCount;
        res.associatedExternalUsersCount = data.AssociatedExternalUsersCount;
        res.associatedHierarchyList = [];
        if (data.AssociatedHierarchyList) {
            data.AssociatedHierarchyList.forEach((c) => {
                res.associatedHierarchyList.push(FolderHierarchy.parseFrom(c));
            });
        }
        if (data.OrganizationId != null) res.organizationId = data.OrganizationId;

        return res;
    }
}
